import React from 'react'
import OurBusinessStyles from './Opportunites.module.css'
import { Box, Button, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import IconButton from '@mui/material/IconButton';
import EditNoteOutlinedIcon from '@mui/icons-material/EditNoteOutlined';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import { setNotifications } from '../../state/GlobalState'
import { setNotificationCount } from '../../state/GlobalState'
import { fetchNotifications } from '../../state/GlobalState'
import Modal from '@mui/material/Modal';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
    p: 0,
    borderRadius: '10px',
    
  };

const Opportunites = () => {

    const [open, setOpen] = React.useState(false);
    // const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const name=useSelector((state)=>state.globalData.name);
    const count=useSelector((state)=>state.globalData.notificationCount);
    const dispatch =  useDispatch()

    const business = [1, 2, 3]

    const [data, setData] = useState([])
    const [selectedPdfId, setSelectedPdfId] = useState(null);

    const handleOpen = (pdfId) => {
        setSelectedPdfId(pdfId);
        setOpen(true);
      };
      

    const getBusinessData = async () => {
        try {
            const res = await axios.get(
                `${process.env.REACT_APP_STEELADMIN}/partnerOpp/getAllPartnerOpp`
            )
            setData(res.data)
            // console.log(res.data)
        } catch (error) {
            console.log(error)
        }    
    }

    const deleteBusinessbyId = async (pdfId) => {
        try {
            const res = await axios.delete(
                `${process.env.REACT_APP_STEELADMIN}/partnerOpp/deleteOppById/${pdfId}`
            )
                 // this is the snipte for the notification 
           dispatch(fetchNotifications())

           dispatch(setNotificationCount({
            count:count+1,
           }))
            
            // alert('Delete Successful!')
            // window.location.reload()
            getBusinessData()
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getBusinessData()
    }, [])


    return (
        <div className={OurBusinessStyles.ourbusinessMain}>
            <div className={OurBusinessStyles.ourbusinessContent}>
                <div className={OurBusinessStyles.ourbusinessHeader}>
                    <Typography sx={{ marginTop: '1%', color: '#121926', fontWeight: '600', fontSize: '20px' ,paddingBottom:'2%'}} >
                    Opportunites
                    </Typography>
                    <Link to='/addopportunites'>
                        <Button sx={{ textTransform: 'capitalize' }} variant='contained'>Add Opportunites</Button>
                    </Link>
                </div>
                <Box className={OurBusinessStyles.ourbusinessComponent}>
                    <div className={OurBusinessStyles.ourbusinessComponentLeft}>
                        <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Name
                        </Typography>
                    </div>
                    <div className={OurBusinessStyles.ourbusinessComponentRight}>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Last modified
                        </Typography>
                        <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600' }}>
                            Action
                        </Typography>
                    </div>
                </Box>
                {data.map((business) =>
                    <Box className={OurBusinessStyles.ourbusinessComponent}>
                        <div className={OurBusinessStyles.ourbusinessComponentLeft}>
                            <Typography variant='h5' sx={{ fontSize: '15px', fontWeight: '600' }}>
                                {business.partOpp?.partnerOppName}
                            </Typography>
                        </div>
                        <div className={OurBusinessStyles.ourbusinessComponentRight}>
                            <Typography variant='h6' sx={{ fontSize: '15px' }}>
                                {business.date}
                            </Typography>
                            <Typography variant='h6' sx={{ fontSize: '15px', fontWeight: '600', display: 'flex', alignItems: 'baseline' }}>
                                <Link to='/editopportunites' state={business} style={{marginRight:'10%'}} >
                                    <BorderColorOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
                                </Link>
                                <IconButton disableRipple onClick={() => handleOpen(business.pdfId)}>
  <DeleteForeverOutlinedIcon sx={{ color: '#16469d', cursor: 'pointer' }} />
</IconButton>

                            </Typography>
                        </div>
                    </Box>
                ).reverse()}
            </div>
            <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
        sx={{
            borderRadius:'10px',
        }}
      >
        {/* onClick={() => deleteBusinessbyId(business.pdfId)} */}
        <Box sx={style} >
          <Typography id="keep-mounted-modal-title" variant="h6" component="h2"
          sx={{
            fontSize:'20px',
            color:'25px',
            lineHeight:'#181818',
           p: 7,
            width:'100%',
            display:'flex',
            justifyContent:'center',
            textAlign:'center',
            alignItems:'center',
            fontWeight:'600',


          }}>
          Are you sure want to delete the entry?
          </Typography>
          <Box
          
          sx={{
            width:'100%',
            mt:'2%',

          }}>
    <Link to='/opportunites'>
    <Button
  sx={{
    width: '50%',
    mt: '2%',
    p: '3%',
    borderBottomLeftRadius: '1%'
  }}
  variant="contained"
        disableRipple
        onClick={async () => {
          await deleteBusinessbyId(selectedPdfId);
          handleClose(); // Close the modal after successful deletion
        }}
  
>
  Yes
</Button>

    </Link>
          <Button 
          sx={{
            width:'50%',
            mt:'2%',
            p:'3%',
            borderRadius:'0',

          }}
          onClick={handleClose}
           variant='outlined'>No</Button>
          </Box>
          
        </Box>
      </Modal>
        </div>
    )
}

export default Opportunites